import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    en: {
        translation: {
            "nav": {
                "courses": "Courses",
                "best_colleges": "Best Colleges",
                "study_abroad": "Study Abroad",
                "career_insights": "Career Insights",
                "benefits": "Benefits",
                "counseling": "Counseling",
                "login": "Login",
                "register": "Register"
            },
            "home": {
                "badge": "From Interest to Career",
                "june": {
                    "badge": "Beta",
                    "hero_title": "Turn Your <0>Creativity Into a Career.</0>",
                    "hero_subtitle": "Explore design careers, choose the right path, and get into top colleges with expert guidance."
                },
                "hero_title": "Turn Your <0>Creativity Into a Career.</0>",
                "hero_subtitle": "Explore design careers, choose the right path, and get into top colleges with expert guidance.",
                "cta_quiz": "Start Career Assessment",
                "cta_explore": "Browse Courses",
                "stats": {
                    "scholarships": "Design Career Paths",
                    "eager_score": "Avg Eager Index",
                    "recruiters": "Design Colleges"
                },
                "value_prop_title": "Don't just be a <0>Roll Number</0>.",
                "value_prop_desc": "Eager changes the game by quantifying your <0>Real World Value</0>.",
                "cards": {
                    "potential_title": "Prove Your Potential",
                    "potential_desc": "Take our advanced assessment to generate your <0>Eager Score</0>. It goes beyond marks to measure Logic, Art, and EQ.",
                    "grants_title": "Unlock Grants",
                    "grants_desc": "High score? Get paid. Unlock \"Success Grants\" worth up to <0>₹10,000</0> just for proving you are consistent.",
                    "scout_title": "Get Scouted",
                    "scout_desc": "Turn on \"Scout Mode\" to let top companies see your profile. Skip the resume pile and get <0>Direct Offers</0>."
                },
                "promise": {
                    "badge": "Our Pledge",
                    "title": "We are on <0>Your Side.</0>",
                    "desc": "We built Eager to give students leverage, transparency, and respect.",
                    "promises": {
                        "zero_spam_title": "Zero Spam Guarantee",
                        "zero_spam_desc": "We never sell your data. Recruiter calls are <0>Invite-Only</0>. You only hear from colleges YOU shortlist or accept interest from.",
                        "reality_title": "Reality, Not Ads",
                        "reality_desc": "Our \"Reality Check\" reviews are verified by student IDs. We show the <0>Good, Bad, and Ugly</0> so you don't walk into a trap.",
                        "guarantee_title": "The Eager Guarantee",
                        "guarantee_desc": "If you secure admission via Eager, we verify your scholarship and stand by you. We are your <0>Career Bodyguards</0>."
                    },
                    "trust_title": "Trusted by 2,400+ Students this month.",
                    "trust_desc": "Join the movement demanding better education."
                },
                "philosophy": {
                    "badge": "Core Values",
                    "title": "Our Philosophy",
                    "desc": "We built Eager to solve the confusion students face. These core beliefs drive every feature we build, ensuring you get unbiased and relevant guidance.",
                    "values": {
                        "path_title": "We don’t force one path",
                        "path_desc": "Your journey is unique. We provide the map, but you choose the destination based on what feels right for you.",
                        "options_title": "We show multiple options",
                        "options_desc": "From traditional degrees to emerging tech and creative fields, we present every viable route so you never miss out.",
                        "fit_title": "We focus on fit, not hype",
                        "fit_desc": "Trending careers aren't always the best fit. We help you discover roles that align with your natural strengths.",
                        "evolve_title": "We update paths as careers evolve",
                        "evolve_desc": "The world changes fast. Our data stays current so you're prepared for everything from neurosurgery to being a professional athlete or tour guide.",
                        "roi_title": "Beyond the Paycheck",
                        "roi_desc": "While we track ROI, salary projection is not our priority. We value small, fulfilling roles just as much as high-stakes ones. Your happiness is the ultimate ROI."
                    }
                },
                "global": {
                    "badge": "Go Global",
                    "title": "Your Dream University <0>Has No Borders.</0>",
                    "desc": "USA, UK, Canada, or Australia? We help you navigate the chaos of international admissions. Find universities, check eligibility, and understand visa requirements in one place.",
                    "cta": "Explore Study Abroad"
                },
                "final_cta": {
                    "title": "Ready to Level Up?",
                    "desc": "Join 10,000+ students who have already claimed their Eager Identity. It takes 5 minutes, and it's free.",
                    "button": "Build My Eager Score"
                }
            },
            "benefits": {
                "hero": {
                    "badge": "High-Speed Benefits Hub",
                    "title": "Your Career <0>Accelerator</0>",
                    "desc": "One dashboard for all your success tools. Track entrance exams, compare packages, and find financial aid instantly."
                },
                "tabs": {
                    "overview": "Overview",
                    "roadmap": "Career Roadmap",
                    "exams": "Admission Tracker",
                    "placements": "Career Insights",
                    "scholarships": "Student Aid",
                    "grants": "Eager Grant"
                },
                "overview": {
                    "cards": {
                        "exams_title": "Admission Tracker",
                        "exams_desc": "Real-time tracking of 50+ entrance exams and key deadlines.",
                        "placements_title": "Career Insights",
                        "placements_desc": "Analyze ROI and placement data across top colleges.",
                        "scholarships_title": "Student Aid",
                        "scholarships_desc": "Unlock financial aid from a curated database of scholarships.",
                        "grants_title": "Eager Grant",
                        "grants_desc": "Earn ₹2,500 assured when you secure admission through the Eager platform.",
                        "explore": "Explore"
                    },
                    "stats": {
                        "title": "Why use the Success Dashboard?",
                        "point1": "Unified tracking reduces the risk of missing critical application deadlines.",
                        "point2": "Data-driven insights help you choose colleges with the best ROI."
                    }
                },
                "grant": {
                    "badge_elite": "Academic Excellence Reward",
                    "badge_regular": "Eager Student Grant",
                    "title": "Eager Student Grant",
                    "desc_elite": "Because of your exceptional Eager Score (800+), we have upgraded your grant. Eager invests more in students who prove their dedication.",
                    "desc_regular": "We believe in investing in your future. Secure an admission through Eager and receive a guaranteed grant to jumpstart your journey.",
                    "cta": "Check My Eligibility",
                    "pro_tip": "Pro Tip:",
                    "pro_tip_desc": "Reach a score of 800 to unlock the <0>₹5,000 Elite Grant</0>.",
                    "how_title": "How it Works?",
                    "steps": {
                        "1": "Explore & find a college with the 'Verified Reward' badge.",
                        "2": "Apply and secure your admission through our platform link.",
                        "3": "Upload your admission proof to your Eager dashboard.",
                        "4": "Receive your Grant as a direct voucher or Amazon Gift Card."
                    },
                    "why_title": "Why are we doing this?",
                    "why_desc": "Admissions can be expensive. Whether it's buying a new bag, upgrading your laptop, or just purchasing your first-semester books—we want to be the ones who help you take that first step.",
                    "mission": "\"Our mission isn't just to find you a seat, but to ensure you have everything you need to succeed in it.\""
                }
            },
            "profile": {
                "ghost": {
                    "title": "Ghost Profile?",
                    "desc": "We couldn't find your profile data. You might need to sign in again.",
                    "signin": "Sign In / Register",
                    "retry": "Retry"
                },
                "scout_mode": "Scout Mode Active",
                "cards": {
                    "readiness": "Scout Readiness",
                    "academic": "Academic",
                    "archetype": "Archetype",
                    "momentum": "Momentum",
                    "peak": "Peak",
                    "rising": "Rising",
                    "verified": "Verified Identity",
                    "title_default": "Eager Explorer"
                },
                "stats_card": {
                    "title": "Skill Breakdown",
                    "footer": "Stats update automatically based on your Quiz performance and Platform activity.",
                    "logic": "Logic",
                    "creativity": "Creativity",
                    "leadership": "Leadership",
                    "profileviews": "Profile Views",
                    "shortlisted": "Shortlisted",
                    "applications": "Applications"
                },
                "scout_mode_card": {
                    "title": "Scout Mode",
                    "active": "Active & Visible",
                    "inactive": "Currently Hidden",
                    "desc_active": "Allow verified colleges and recruiters to view your achievements and offer scholarships.",
                    "desc_inactive": "Activate to let colleges view your profile.",
                    "companies_viewing": "Companies Viewing",
                    "preview_button": "Preview Public Card"
                },
                "global_rank": {
                    "top_percent": "Top",
                    "global": "Global",
                    "outperforming_desc": "You are outperforming {{percent}}% of Eager Explorers globally.",
                    "leaderboard": "Leaderboard"
                },
                "activity": {
                    "quiz_completed": "Completed \"Career Compatibility Quiz\"",
                    "colleges_shortlisted": "Shortlisted {{count}} new Engineering Colleges",
                    "days_ago": "{{count}} days ago"
                },
                "onboarding": {
                    "title": "Level Up Your Eager Identity",
                    "subtitle": "Complete these steps to unlock Scout Mode and get noticed by recruiters.",
                    "potential_points": "Potential Points",
                    "completion": "Completion",
                    "steps": {
                        "avatar": "Add a Professional Photo",
                        "quiz": "Complete Career Quiz",
                        "location": "Update Home City",
                        "interests": "Pick 3 Interests",
                        "skills": "Add Your First Skill",
                        "projects": "Showcase a Project",
                        "status": "Completed"
                    }
                },
                "psychometric": {
                    "title": "Psychometric Insight",
                    "result_prefix": "You are a",
                    "button": "View Full Report",
                    "descriptions": {
                        "explorer": "You are the detective of the world. Curiosity drives you. You love to analyze, research, and solve complex puzzles.... Discover why colleges are looking for your unique blend of skills."
                    }
                },
                "share_button": {
                    "default": "Share Eager One Card",
                    "preparing": "Preparing Scorecard...",
                    "ready": "Ready to Post!",
                    "failed": "Capture Failed"
                },
                "scout_one": {
                    "foundation_stage": "FOUNDATION STAGE"
                },
                "titles": {
                    "identity": "Level Up Your Eager Identity",
                    "interests": "Career Interests",
                    "skills": "Verified Skills",
                    "projects": "Projects",
                    "badges": "Earned Badges",
                    "activity": "Recent Activity",
                    "academic": "Academic Stack"
                }
            }
        }
    },
    te: {
        translation: {
            "nav": {
                "courses": "కోర్సులు",
                "best_colleges": "ఉత్తమ కళాశాలలు",
                "study_abroad": "విదేశాలలో విద్య",
                "career_insights": "కెరీర్ చిట్కాలు",
                "benefits": "ప్రయోజనాలు",
                "counseling": "కౌన్సిలింగ్",
                "login": "లాగిన్",
                "register": "రిజిస్టర్"
            },
            "home": {
                "badge": "ఆసక్తి నుండి కెరీర్ వరకు",
                "hero_title": "మీ <0>దిశను</0> కనుగొనండి.",
                "hero_subtitle": "మార్కులు సగం కథనే చెబుతాయి. మేము మీ <0>పూర్తి సామర్థ్యాన్ని</0> కొలుస్తాము. మీ <1>ఈగర్ స్కోరు</1>ను పెంచుకోండి, స్కాలర్‌షిప్‌లు పొందండి మరియు కంపెనీల నుండి ఆహ్వానాలు అందుకోండి.",
                "cta_quiz": "మీ నైపుణ్యాన్ని తెలుసుకోండి",
                "cta_explore": "కోర్సులను అన్వేషించండి",
                "stats": {
                    "scholarships": "స్కాలర్‌షిప్‌లు",
                    "eager_score": "సగటు ఈగర్ స్కోర్",
                    "recruiters": "పాలుదారుల"
                },
                "value_prop_title": "కేవలం ఒక <0>రోల్ నంబర్</0> లా ఉండకండి.",
                "value_prop_desc": "సాంప్రదాయ విద్యా విధానం మారింది. అది మీ నాయకత్వం, సృజనాత్మకతను విస్మరిస్తుంది. ఈగర్ మీ <0>నిజమైన విలువను</0> గుర్తించి మార్పు తెస్తుంది.",
                "cards": {
                    "potential_title": "మీ సామర్థ్యాన్ని నిరూపించుకోండి",
                    "potential_desc": "మా అధునాతన పరీక్షతో మీ <0>ఈగర్ స్కోరు</0>ను తెలుసుకోండి. ఇది మార్కుల కంటే ఎక్కువ.",
                    "grants_title": "గ్రాంట్స్ పొందండి",
                    "grants_desc": "మంచి స్కోరు ఉందా? మీ ప్రతిభకు <0>₹10,000</0> వరకు గ్రాంట్స్ పొందండి.",
                    "scout_title": "స్కౌట్ అవ్వండి",
                    "scout_desc": "\"స్కౌట్ మోడ్\" ఆన్ చేయండి, కంపెనీలు మిమ్మల్ని చూస్తాయి. రెజ్యూమ్ పంపకుండానే <0>డైరెక్ట్ ఆఫర్లు</0> పొందండి."
                },
                "promise": {
                    "badge": "మా ప్రతిజ్ఞ",
                    "title": "మేము <0>మీ పక్షాన</0> ఉంటాము.",
                    "desc": "విద్యార్థులకు గౌరవం మరియు పారదర్శకత కల్పించడానికి మేము ఈగర్ నిర్మించాము.",
                    "promises": {
                        "zero_spam_title": "స్పామ్ లేదు",
                        "zero_spam_desc": "మీ డేటాను మేము ఎవరికీ అమ్మము. రిక్రూటర్ కాల్స్ కేవలం <0>ఆహ్వానం మేరకు</0> మాత్రమే వస్తాయి. మీరు ఆసక్తి చూపిన వారి నుంచే మీకు కాల్స్ వస్తాయి.",
                        "reality_title": "నిజం, ప్రకటనలు కాదు",
                        "reality_desc": "మా \"రియాలిటీ చెక్\" సమీక్షలు విద్యార్థులచే ధృవీకరించబడినవి. మేము <0>మంచి, చెడు మరియు నిజాన్ని</0> చూపిస్తాము, తద్వారా మీరు మోసపోరు.",
                        "guarantee_title": "ఈగర్ వారంటీ",
                        "guarantee_desc": "మీరు ఈగర్ ద్వారా అడ్మిషన్ పొందితే, మేము మీ స్కాలర్‌షిప్‌ను ధృవీకరిస్తాము మరియు మీకు అండగా ఉంటాము. మేము మీ <0>కెరీర్ బాడీగార్డ్స్</0>."
                    },
                    "trust_title": "ఈ నెలలో 2,400+ విద్యార్థుల నమ్మకం.",
                    "trust_desc": "మెరుగైన విద్య కోసం ఉద్యమంలో చేరండి."
                },
                "philosophy": {
                    "badge": "మా విలువలు",
                    "title": "మా తత్వం",
                    "desc": "విద్యార్థుల గందరగోళాన్ని తొలగించడానికి ఈగర్ ఉంది. మీకు సరైన మార్గనిర్దేశం చేయడమే మా లక్ష్యం.",
                    "values": {
                        "path_title": "మేము ఒకే మార్గాన్ని రుద్దము",
                        "path_desc": "మీ ప్రయాణం ప్రత్యేకమైనది. మేము మ్యాప్‌ని మాత్రమే ఇస్తాము, గమ్యాన్ని మీరే ఎంచుకోవాలి.",
                        "options_title": "మేము అనేక మార్గాలను చూపిస్తాము",
                        "options_desc": "సాంప్రదాయ డిగ్రీల నుండి కొత్త టెక్నాలజీల వరకు, మేము ప్రతి అవకాశాన్ని చూపిస్తాము.",
                        "fit_title": "మేము ఫిట్‌నెస్‌పై దృష్టి పెడతాము, హైప్‌పై కాదు",
                        "fit_desc": "ట్రెండింగ్ కెరీర్‌లు ఎప్పుడూ సరైనవి కావు. మీ బలానికి సరిపోయే పాత్రలను కనుగొనడంలో సహాయపడతాము.",
                        "evolve_title": "కెరీర్‌లు మారినప్పుడు మేము అప్‌డేట్ చేస్తాము",
                        "evolve_desc": "ప్రపంచం వేగంగా మారుతోంది. మా సమాచారం ఎప్పటికప్పుడు అప్‌డేట్ అవుతుంది.",
                        "roi_title": "జీతానికి మించి",
                        "roi_desc": "జీతం ముఖ్యం, కానీ మీ సంతోషం అంతకంటే ముఖ్యం. సంతృప్తినిచ్చే చిన్న పాత్రలకు కూడా మేము విలువ ఇస్తాము."
                    }
                },
                "global": {
                    "badge": "ప్రపంచవ్యాప్తంగా వెళ్ళండి",
                    "title": "మీ కలల యూనివర్సిటీకి <0>హద్దులు లేవు.</0>",
                    "desc": "అమెరికా, యూకే, కెనడా లేదా ఆస్ట్రేలియా? అంతర్జాతీయ అడ్మిషన్ల గందరగోళాన్ని దాటడంలో మేము సహాయపడతాము. యూనివర్సిటీలను కనుగొనండి, వీసా వివరాలు తెలుసుకోండి.",
                    "cta": "విదేశీ విద్యను అన్వేషించండి"
                },
                "final_cta": {
                    "title": "సిద్ధంగా ఉన్నారా?",
                    "desc": "10,000+ మంది విద్యార్థులతో చేరండి. ఇది ఉచితం మరియు కేవలం 5 నిమిషాలు పడుతుంది.",
                    "button": "నా ఈగర్ స్కోర్ బిల్డ్ చేయండి"
                }
            },
            "benefits": {
                "hero": {
                    "badge": "హై-స్పీడ్ బెనిఫిట్స్ హబ్",
                    "title": "మీ కెరీర్ <0>యాక్సిలరేటర్</0>",
                    "desc": "ఒకే డాష్‌ బోర్డ్ లో మీ విజయానికి కావాల్సిన అన్ని టూల్స్. ఎగ్జామ్స్ ట్రాక్ చేయండి, ప్యాకేజీలను పోల్చండి మరియు స్కాలర్​షిప్స్ పొందండి."
                },
                "tabs": {
                    "overview": "అవలోకనం",
                    "roadmap": "కెరీర్ రోడ్‌మ్యాప్",
                    "exams": "అడ్మిషన్ కమాండ్",
                    "placements": "మార్కెట్ కమాండ్",
                    "scholarships": "ఆర్థిక ఙ్ఞానం",
                    "grants": "సక్సెస్ గ్రాంట్"
                },
                "overview": {
                    "cards": {
                        "exams_title": "అడ్మిషన్ కమాండ్",
                        "exams_desc": "50+ ప్రవేశ పరీక్షలు మరియు డెడ్‌లైన్‌లను రియల్ టైమ్ లో ట్రాక్ చేయండి.",
                        "placements_title": "మార్కెట్ కమాండ్",
                        "placements_desc": "ఉత్తమ కళాశాలల ROI మరియు ప్యాకేజీలను విశ్లేషించండి.",
                        "scholarships_title": "ఆర్థిక ఙ్ఞానం",
                        "scholarships_desc": "మా డేటాబేస్ నుండి ఆర్థిక సహాయం (స్కాలర్‌షిప్‌లు) పొందండి.",
                        "grants_title": "సక్సెస్ గ్రాంట్",
                        "grants_desc": "ఈగర్ ద్వారా అడ్మిషన్ పొందితే ₹2,500 ఖచ్చితంగా పొందండి.",
                        "explore": "అన్వేషించండి"
                    },
                    "stats": {
                        "title": "సక్సెస్ డాష్‌బోర్డ్ ఎందుకు వాడాలి?",
                        "point1": "ఒకే చోట ట్రాకింగ్ వల్ల అప్లికేషన్ డెడ్‌లైన్‌లు మిస్ అయ్యే ప్రమాదం ఉండదు.",
                        "point2": "డేటా ఆధారిత సమాచారం మీకు మంచి ROI ఉన్న కాలేజీలను ఎంచుకోవడంలో సహాయపడుతుంది."
                    }
                },
                "grant": {
                    "badge_elite": "ఎలైట్ బెనిఫిట్ అన్‌లాక్ చేయబడింది",
                    "badge_regular": "ఎక్స్‌క్లూజివ్ ఈగర్ గ్రాంట్",
                    "title": "సక్సెస్ గ్రాంట్",
                    "desc_elite": "మీ అద్భుతమైన ఈగర్ స్కోర్ (800+) కారణంగా, మేము మీ గ్రాంట్‌ను అప్‌గ్రేడ్ చేసాము. అంకితభావం ఉన్న విద్యార్థులకు ఈగర్ ఎక్కువ పెట్టుబడి పెడుతుంది.",
                    "desc_regular": "మేము మీ భవిష్యత్తుపై పెట్టుబడి పెట్టాలని నమ్ముతున్నాము. ఈగర్ ద్వారా అడ్మిషన్ పొందండి మరియు మీ ప్రయాణాన్ని ప్రారంభించడానికి గ్రాంట్‌ను పొందండి.",
                    "cta": "నా అర్హతను తనిఖీ చేయండి",
                    "pro_tip": "ప్రో చిట్కా:",
                    "pro_tip_desc": "<0>₹5,000 ఎలైట్ గ్రాంట్</0> అన్‌లాక్ చేయడానికి 800 స్కోరు సాధించండి.",
                    "how_title": "ఇది ఎలా పని చేస్తుంది?",
                    "steps": {
                        "1": "'వెరిఫైడ్ రివార్డ్' బ్యాడ్జ్ ఉన్న కళాశాలను కనుగొనండి.",
                        "2": "మా ప్లాట్‌ఫారమ్ లింక్ ద్వారా అప్లై చేసి అడ్మిషన్ పొందండి.",
                        "3": "మీ అడ్మిషన్ ప్రూఫ్ ను మీ ఈగర్ డాష్‌బోర్డ్‌లో అప్‌లోడ్ చేయండి.",
                        "4": "మీ గ్రాంట్‌ను వోచర్ లేదా అమెజాన్ గిఫ్ట్ కార్డ్‌గా పొందండి."
                    },
                    "why_title": "మేము ఎందుకు చేస్తున్నాము?",
                    "why_desc": "అడ్మిషన్లు ఖరీదైనవి. కొత్త బ్యాగ్ కొనడం, ల్యాప్‌టాప్ అప్‌గ్రేడ్ చేయడం లేదా పుస్తకాలు కొనడం—మీ మొదటి అడుగులో మేము సహాయం చేయాలనుకుంటున్నాము.",
                    "mission": "\"మా లక్ష్యం కేవలం మీకు సీటు ఇప్పించడం కాదు, అందులో రాణించడానికి మీకు కావాల్సినవన్నీ అందించడం.\""
                }
            },
            "profile": {
                "ghost": {
                    "title": "ఘోస్ట్ ప్రొఫైల్?",
                    "desc": "మేము మీ ప్రొఫైల్ డేటాను కనుగొనలేకపోయాము. మీరు మళ్లీ సైన్ ఇన్ చేయాల్సి ఉంటుంది.",
                    "signin": "సైన్ ఇన్ / ರಿజిస్టర్",
                    "retry": "మళ్ళీ ప్రయత్నించండి"
                },
                "scout_mode": "స్కౌట్ మోడ్ యాక్టివ్",
                "cards": {
                    "readiness": "స్కౌట్ సంసిద్ధత",
                    "academic": "అకడమిక్",
                    "archetype": "ఆర్కిటైప్",
                    "momentum": "మొమెంటం",
                    "peak": "శిఖరాగ్రం",
                    "rising": "ఎదుగుతున్న",
                    "verified": "వెరిఫైడ్ ఐడెంటిటీ",
                    "title_default": "ఈగర్ ఎక్స్‌ప్లోరర్"
                },
                "stats_card": {
                    "title": "నైపుణ్య విశ్లేషణ",
                    "footer": "మీ క్విజ్ పనితీరు ఆధారంగా గణాంకాలు అప్‌డేట్ అవుతాయి.",
                    "logic": "లాజిక్",
                    "creativity": "సృజనాత్మకత",
                    "leadership": "నాయకత్వం",
                    "profileviews": "ప్రొఫైల్ వీక్షణలు",
                    "shortlisted": "షార్ట్‌లిస్ట్",
                    "applications": "అప్లికేషన్లు"
                },
                "scout_mode_card": {
                    "title": "స్కౌట్ మోడ్",
                    "active": "యాక్టివ్ & విజిబుల్",
                    "inactive": "ప్రస్తుతం దాచబడింది",
                    "desc_active": "ధృవీకరించబడిన కళాశాలలు మరియు రిక్రూటర్‌లు మీ విజయాలను వీక్షించడానికి మరియు స్కాలర్‌షిప్‌లను అందించడానికి అనుమతించండి.",
                    "desc_inactive": "కళాశాలలు మీ ప్రొఫైల్‌ను వీక్షించడానికి యాక్టివేట్ చేయండి.",
                    "companies_viewing": "కంపెనీలు చూస్తున్నాయి",
                    "preview_button": "పబ్లిక్ కార్డ్ ప్రివ్యూ"
                },
                "global_rank": {
                    "top_percent": "టాప్",
                    "global": "గ్లోబల్",
                    "outperforming_desc": "మీరు ప్రపంచవ్యాప్తంగా {{percent}}% మంది ఈగర్ ఎక్స్‌ప్లోరర్‌ల కంటే మెరుగ్గా రాణిస్తున్నారు.",
                    "leaderboard": "లీడర్‌బోర్డ్"
                },
                "activity": {
                    "quiz_completed": "\"కెరీర్ కంపాటిబిలిటీ క్విజ్\" పూర్తి చేసారు",
                    "colleges_shortlisted": "{{count}} కొత్త ఇంజనీరింగ్ కళాశాలలు షార్ట్‌లిస్ట్ చేయబడ్డాయి",
                    "days_ago": "{{count}} రోజుల క్రితం"
                },
                "onboarding": {
                    "title": "మీ ఈగర్ ఐడెంటిటీని పెంచుకోండి",
                    "subtitle": "స్కౌట్ మోడ్‌ని అన్‌లాక్ చేయడానికి మరియు రిక్రూటర్‌ల దృష్టిని ఆకర్షించడానికి ఈ దశలను పూర్తి చేయండి.",
                    "potential_points": "పొటెన్షియల్ పాయింట్లు",
                    "completion": "పూర్తి శాతం",
                    "steps": {
                        "avatar": "ప్రొఫెషనల్ ఫోటోను జోడించండి",
                        "quiz": "కెరీర్ క్విజ్ పూర్తి చేయండి",
                        "location": "పుట్టిన ఊరు అప్‌డేట్ చేయండి",
                        "interests": "3 ఆసక్తులను ఎంచుకోండి",
                        "skills": "మీ మొదటి నైపుణ్యాన్ని జోడించండి",
                        "projects": "ప్రాజెక్ట్‌ను ప్రదర్శించండి",
                        "status": "పూర్తయింది"
                    }
                },
                "psychometric": {
                    "title": "సైకోమెట్రిక్ విశ్లేషణ",
                    "result_prefix": "మీరు ఒక",
                    "button": "పూర్తి నివేదికను చూడండి",
                    "descriptions": {
                        "explorer": "మీరు ప్రపంచానికి డిటెక్టివ్. ఉత్సుకత మిమ్మల్ని నడిపిస్తుంది. మీరు విశ్లేషించడం, పరిశోధించడం మరియు సంక్లిష్టమైన పజిల్‌లను పరిష్కరించడం ఇష్టపడతారు.... కళాశాలలు మీ ప్రత్యేక నైపుణ్యాల కోసం ఎందుకు వెతుకుతున్నాయో కనుగొనండి."
                    }
                },
                "share_button": {
                    "default": "ఈగర్ వన్ కార్డ్‌ని షేర్ చేయండి",
                    "preparing": "స్కోర్‌కార్డ్ సిద్ధం అవుతోంది...",
                    "ready": "పోస్ట్ చేయడానికి సిద్ధం!",
                    "failed": "క్యాప్చర్ విఫలమైంది"
                },
                "scout_one": {
                    "foundation_stage": "పునాది దశ"
                },
                "titles": {
                    "identity": "మీ ఈగర్ ఐడెంటిటీని పెంచుకోండి",
                    "interests": "కెరీర్ ఆసక్తులు",
                    "skills": "ధృవీకరించబడిన నైపుణ్యాలు",
                    "projects": "ప్రాజెక్టులు",
                    "badges": "సాధించిన బ్యాడ్జ్‌లు",
                    "activity": "ఇటీవలి కార్యకలాపాలు",
                    "academic": "అకడమిక్ వివరాలు"
                }
            }
        }
    },
    kn: {
        translation: {
            "nav": {
                "courses": "ಕೋರ್ಸ್‌ಗಳು",
                "best_colleges": "ಅತ್ಯುತ್ತಮ ಕಾಲೇಜುಗಳು",
                "study_abroad": "ವಿದೇಶ ವ್ಯಾಸಂಗ",
                "career_insights": "ವೃತ್ತಿ ಮಾಹಿತಿ",
                "benefits": "ಪ್ರಯೋಜನಗಳು",
                "counseling": "ಕೌನ್ಸೆಲಿಂಗ್",
                "login": "ಲಾಗಿನ್",
                "register": "ನೋಂದಣಿ"
            },
            "home": {
                "badge": "ಆಸಕ್ತಿಯಿಂದ ವೃತ್ತಿಜೀವನದತ್ತ",
                "hero_title": "ನಿಮ್ಮ <0>ದಿಸೆಯನ್ನು</0> ಕಂಡುಕೊಳ್ಳಿ.",
                "hero_subtitle": "ಅಂಕಗಳು ಅರ್ಧ ಕಥೆಯನ್ನು ಮಾತ್ರ ಹೇಳುತ್ತವೆ. ನಾವು ನಿಮ್ಮ <0>ಸಂಪೂರ್ಣ ಸಾಮರ್ಥ್ಯವನ್ನು</0> ಅಳೆಯುತ್ತೇವೆ. ನಿಮ್ಮ <1>ಈಗರ್ ಸ್ಕೋರ್</1> ಹೆಚ್ಚಿಸಿಕೊಳ್ಳಿ, ಸ್ಕಾಲರ್‌ಶಿಪ್ ಪಡೆಯಿರಿ.",
                "cta_quiz": "ನಿಮ್ಮ ಕೌಶಲ್ಯ ತಿಳಿಯಿರಿ",
                "cta_explore": "ಕೋರ್ಸ್‌ಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",
                "stats": {
                    "scholarships": "ಸ್ಕಾಲರ್‌ಶಿಪ್‌ಗಳು",
                    "eager_score": "ಸರಾಸರಿ ಈಗರ್ ಸ್ಕೋರ್",
                    "recruiters": "ಪಾಲುದಾರರು"
                },
                "value_prop_title": "ಕೇವಲ <0>ರೋಲ್ ನಂಬರ್</0> ಆಗಿರಬೇಡಿ.",
                "value_prop_desc": "ಸಾಂಪ್ರದಾಯಿಕ ವ್ಯವಸ್ಥೆ ಹಳೆಯದಾಗಿದೆ. ಅದು ನಿಮ್ಮ ನಾಯಕತ್ವ ಮತ್ತು ಸೃಜನಶೀಲತೆಯನ್ನು ನಿರ್ಲಕ್ಷಿಸುತ್ತದೆ. ಈಗರ್ ನಿಮ್ಮ <0>ನೈಜ ಮೌಲ್ಯವನ್ನು</0> ಗುರುತಿಸುತ್ತದೆ.",
                "cards": {
                    "potential_title": "ಸಾಮರ್ಥ್ಯವನ್ನು ಸಾಬೀತುಪಡಿಸಿ",
                    "potential_desc": "ನಮ್ಮ ಸುಧಾರಿತ ಪರೀಕ್ಷೆಯ ಮೂಲಕ ನಿಮ್ಮ <0>ಈಗರ್ ಸ್ಕೋರ್</0> ಪಡೆಯಿರಿ. ಇದು ಅಂಕಗಳಿಗಿಂತ ಮಿಗಿಲು.",
                    "grants_title": "ಅನುದಾನ ಪಡೆಯಿರಿ",
                    "grants_desc": "ಉತ್ತಮ ಸ್ಕೋರ್ ಇದೆಯೇ? ನಿಮ್ಮ ಸಾಧನೆಗೆ <0>₹10,000</0> ವರೆಗೆ ಅನುದಾನ ಪಡೆಯಿರಿ.",
                    "scout_title": "ಸ್ಕೌಟ್ ಆಗಿ",
                    "scout_desc": "\"ಸ್ಕೌಟ್ ಮೋಡ್\" ಆನ್ ಮಾಡಿ, ಕಂಪನಿಗಳು ನಿಮ್ಮನ್ನು ನೋಡುತ್ತವೆ. ನೇರ <0>ಆಫರ್‌ಗಳನ್ನು</0> ಪಡೆಯಿರಿ."
                },
                "promise": {
                    "badge": "ನಮ್ಮ ಪ್ರತಿಜ್ಞೆ",
                    "title": "ನಾವು <0>ನಿಮ್ಮ ಪರವಾಗಿ</0> ಇದ್ದೇವೆ.",
                    "desc": "ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಗೌರವ ಮತ್ತು ಪಾರದರ್ಶಕತೆ ನೀಡಲು ನಾವು ಈಗರ್ ನಿರ್ಮಿಸಿದ್ದೇವೆ.",
                    "promises": {
                        "zero_spam_title": "ಸ್ಪ್ಯಾಮ್ ಇಲ್ಲ",
                        "zero_spam_desc": "ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ನಾವು ಮಾರಾಟ ಮಾಡುವುದಿಲ್ಲ. ನೇಮಕಾತಿದಾರರ ಕರೆಗಳು ಕೇವಲ <0>ಆಹ್ವಾನದ ಮೇರೆಗೆ</0> ಮಾತ್ರ. ನೀವು ಆಯ್ಕೆ ಮಾಡಿದವರಿಂದ ಮಾತ್ರ ಕರೆ ಬರುತ್ತದೆ.",
                        "reality_title": "ನೈಜತೆ, ಜಾಹೀರಾತುಗಳಲ್ಲ",
                        "reality_desc": "ನಮ್ಮ \"ರಿಯಾಲಿಟಿ ಚೆಕ್\" ವಿಮರ್ಶೆಗಳು ವಿದ್ಯಾರ್ಥಿಗಳಿಂದ ದೃಢೀಕರಿಸಲ್ಪಟ್ಟಿವೆ. ನಾವು <0>ಒಳ್ಳೆಯದು, ಕೆಟ್ಟದ್ದನ್ನು</0> ತೋರಿಸುತ್ತೇವೆ, ಇದರಿಂದ ನೀವು ಮೋಸಹೋಗುವುದಿಲ್ಲ.",
                        "guarantee_title": "ಈಗರ್ ಗ್ಯಾರಂಟಿ",
                        "guarantee_desc": "ನೀವು ಈಗರ್ ಮೂಲಕ ಪ್ರವೇಶ ಪಡೆದರೆ, ನಾವು ನಿಮ್ಮ ವಿದ್ಯಾರ್ಥಿವೇತನವನ್ನು ಪರಿಶೀಲಿಸುತ್ತೇವೆ ಮತ್ತು ನಿಮ್ಮ ಬೆನ್ನಿಗೆ ಇರುತ್ತೇವೆ. ನಾವು ನಿಮ್ಮ <0>ವೃತ್ತಿ ರಕ್ಷಕರು</0>."
                    },
                    "trust_title": "ಈ ತಿಂಗಳು 2,400+ ವಿದ್ಯಾರ್ಥಿಗಳ ನಂಬಿಕೆ.",
                    "trust_desc": "ಉತ್ತಮ ಶಿಕ್ಷಣಕ್ಕಾಗಿ ಚಳುವಳಿಯಲ್ಲಿ ಸೇರಿ."
                },
                "philosophy": {
                    "badge": "ನಮ್ಮ ಮೌಲ್ಯಗಳು",
                    "title": "ನಮ್ಮ ತತ್ವ",
                    "desc": "ವಿದ್ಯಾರ್ಥಿಗಳ ಗೊಂದಲವನ್ನು ಬಗೆಹರಿಸಲು ಈಗರ್ ಇದೆ. ನಿಮಗೆ ಸರಿಯಾದ ಮಾರ್ಗದರ್ಶನ ನೀಡುವುದೇ ನಮ್ಮ ಗುರಿ.",
                    "values": {
                        "path_title": "ನಾವು ಒಂದೇ ಮಾರ್ಗವನ್ನು ಹೇರುವುದಿಲ್ಲ",
                        "path_desc": "ನಿಮ್ಮ ಪ್ರಯಾಣ ವಿಶಿಷ್ಟವಾಗಿದೆ. ನಾವು ನಕ್ಷೆಯನ್ನು ಮಾತ್ರ ನೀಡುತ್ತೇವೆ, ಗಮ್ಯಸ್ಥಾನವನ್ನು ನೀವೇ ಆರಿಸಿಕೊಳ್ಳಬೇಕು.",
                        "options_title": "ನಾವು ಅನೇಕ ಆಯ್ಕೆಗಳನ್ನು ತೋರಿಸುತ್ತೇವೆ",
                        "options_desc": "ಸಾಂಪ್ರದಾಯಿಕ ಪದವಿಗಳಿಂದ ಹೊಸ ತಂತ್ರಜ್ಞಾನಗಳವರೆಗೆ, ನಾವು ಪ್ರತಿ ಅವಕಾಶವನ್ನು ತೋರಿಸುತ್ತೇವೆ.",
                        "fit_title": "ನಾವು ಹೊಂದಾಣಿಕೆಗೆ ಒತ್ತು ನೀಡುತ್ತೇವೆ",
                        "fit_desc": "ಟ್ರೆಂಡಿಂಗ್ ವೃತ್ತಿಗಳು ಯಾವಾಗಲೂ ಸರಿಯಲ್ಲ. ನಿಮ್ಮ ಬಲಕ್ಕೆ ಹೊಂದುವ ಪಾತ್ರಗಳನ್ನು ಕಂಡುಕೊಳ್ಳಲು ಸಹಾಯ ಮಾಡುತ್ತೇವೆ.",
                        "evolve_title": "ವೃತ್ತಿಗಳು ಬದಲಾದಂತೆ ನಾವು ನವೀಕರಿಸುತ್ತೇವೆ",
                        "evolve_desc": "ಪ್ರಪಂಚ ವೇಗವಾಗಿ ಬದಲಾಗುತ್ತಿದೆ. ನಮ್ಮ ಮಾಹಿತಿ ಯಾವಾಗಲೂ ಅಪ್‌ಡೇಟ್ ಆಗಿರುತ್ತದೆ.",
                        "roi_title": "ವೇತನಕ್ಕಿಂತ ಮಿಗಿಲು",
                        "roi_desc": "ವೇತನ ಮುಖ್ಯ, ಆದರೆ ನಿಮ್ಮ ಸಂತೋಷ ಅದಕ್ಕಿಂತ ಮುಖ್ಯ. ತೃಪ್ತಿದಾಯಕ ಸಣ್ಣ ಪಾತ್ರಗಳಿಗೂ ನಾವು ಬೆಲೆ ನೀಡುತ್ತೇವೆ."
                    }
                },
                "global": {
                    "badge": "ವಿಶ್ವಾದ್ಯಂತ ಹೋಗಿ",
                    "title": "ನಿಮ್ಮ ಕನಸಿನ ವಿಶ್ವವಿದ್ಯಾಲಯಕ್ಕೆ <0>ಗಡಿಗಳಿಲ್ಲ.</0>",
                    "desc": "ಅಮೆರಿಕ, ಯುಕೆ, ಕೆನಡಾ ಅಥವಾ ಆಸ್ಟ್ರೇಲಿಯಾ? ಅಂತರರಾಷ್ಟ್ರೀಯ ಪ್ರವೇಶಾತಿಯ ಗೊಂದಲವನ್ನು ದಾಟಲು ನಾವು ಸಹಾಯ ಮಾಡುತ್ತೇವೆ.",
                    "cta": "ವಿದೇಶಿ ವ್ಯಾಸಂಗ ಅನ್ವೇಷಿಸಿ"
                },
                "final_cta": {
                    "title": "ಸಿದ್ಧರಿದ್ದೀರಾ?",
                    "desc": "10,000+ ವಿದ್ಯಾರ್ಥಿಗಳೊಂದಿಗೆ ಸೇರಿ. ಇದು ಉಚಿತ ಮತ್ತು ಕೇವಲ 5 ನಿಮಿష ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ.",
                    "button": "ನನ್ನ ಈಗರ್ ಸ್ಕೋರ್ ಬಿಲ್ಡ್ ಮಾಡಿ"
                }
            },
            "benefits": {
                "hero": {
                    "badge": "ಹై-ಸ್ಪೀಡ್ ಬೆನಿಫಿಟ್ಸ್ ಹಬ್",
                    "title": "ನಿಮ್ಮ ವೃತ್ತಿಜೀವನದ <0>ವೇಗವರ್ಧಕ</0>",
                    "desc": "ನಿಮ್ಮ ಯಶಸ್ಸಿಗೆ ಬೇಕಾದ ಎಲ್ಲಾ ಪರಿಕರಗಳು ಒಂದೇ ಕಡೆ. ಪರೀಕ್ಷೆಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ, ಪ್ಯಾಕೇಜ್‌ಗಳನ್ನು ಹೋಲಿಕೆ ಮಾಡಿ ಮತ್ತು ವಿದ್ಯಾರ್ಥಿವೇತನವನ್ನು ಪಡೆಯಿರಿ."
                },
                "tabs": {
                    "overview": "ಅವಲೋಕನ",
                    "roadmap": "ವೃತ್ತಿ ಮಾರ್ಗಸೂಚಿ",
                    "exams": "ಪ್ರವೇಶಾತಿಗೆ ಮಾರ್ಗದರ್ಶಿ",
                    "placements": "ಮಾರುಕಟ್ಟೆ ಮಾಹಿತಿ",
                    "scholarships": "ಆರ್ಥಿಕ ಜ್ಞಾನ",
                    "grants": "ಯಶಸ್ವಿ ಅನುದಾನ"
                },
                "overview": {
                    "cards": {
                        "exams_title": "ಪ್ರವೇಶಾತಿಗೆ ಮಾರ್ಗದರ್ಶಿ",
                        "exams_desc": "50+ ಪ್ರವೇಶ ಪರೀಕ್ಷೆಗಳು ಮತ್ತು ದಿನಾಂಕಗಳನ್ನು ರಿಯಲ್ ಟೈಮ್‌ನಲ್ಲಿ ಟ್ರ್ಯಾಕ್ ಮಾಡಿ.",
                        "placements_title": "ಮಾರುಕಟ್ಟೆ ಮಾಹಿತಿ",
                        "placements_desc": "ಉನ್ನತ ಕಾಲೇಜುಗಳ ROI ಮತ್ತು ಪ್ಯಾಕೇಜ್‌ಗಳನ್ನು ವಿಶ್ಲೇಷಿಸಿ.",
                        "scholarships_title": "ಆರ್ಥಿಕ ಜ್ಞಾನ",
                        "scholarships_desc": "ನಮ್ಮ ಡೇಟಾಬೇಸ್‌ನಿಂದ ವಿದ್ಯಾರ್ಥಿವೇತನವನ್ನು (ಸ್ಕಾಲರ್‌ಶಿಪ್) ಪಡೆಯಿರಿ.",
                        "grants_title": "ಯಶಸ್ವಿ ಅನುದಾನ",
                        "grants_desc": "ಈಗರ್ ಮೂಲಕ ಪ್ರವೇಶ ಪಡೆದರೆ ₹2,500 ಖಚಿತವಾಗಿ ಪಡೆಯಿರಿ.",
                        "explore": "ಅನ್వేಷಿಸಿ"
                    },
                    "stats": {
                        "title": "ಸಕ್ಸೆಸ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಏಕೆ ಬಳಸಬೇಕು?",
                        "point1": "ಏಕೀಕೃತ ಟ್ರ್ಯಾಕಿಂಗ್ ಅಪ್ಲಿಕೇಶನ್ ಡೆಡ್‌ಲೈನ್‌ಗಳನ್ನು ತಪ್ಪಿಸಿಕೊಳ್ಳುವ ಅಪಾಯವನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ.",
                        "point2": "ಡೇಟಾ ಆಧಾರಿತ ಮಾಹಿತಿಯು ಉತ್ತಮ ROI ಇರುವ ಕಾಲೇಜುಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ."
                    }
                },
                "grant": {
                    "badge_elite": "ಎಲೈಟ್ ಬೆನಿಫిಟ್ ಅನ್ಲಾಕ್ ಆಗಿದೆ",
                    "badge_regular": "ವಿಶೇಷ ಈಗರ್ ಅನುದಾನ",
                    "title": "ಯಶಸ್ವಿ ಅನುದಾನ",
                    "desc_elite": "ನಿಮ್ಮ ಅತ್ಯುತ್ತಮ ಈಗರ್ ಸ್ಕೋರ್ (800+) ಕಾರಣ, ನಾವು ನಿಮ್ಮ ಅನುದಾನವನ್ನು ಹೆಚ್ಚಿಸಿದ್ದೇವೆ. ಸಮರ್ಪಣಾ ಮನೋಭಾವ ಹೊಂದಿರುವ ವಿದ್ಯಾರ್ಥಿಗಳಲ್ಲಿ ಈಗರ್ ಹೆಚ್ಚು ಹೂಡಿಕೆ ಮಾಡುತ್ತದೆ.",
                    "desc_regular": "ನಿಮ್ಮ ಭವಿಷ್ಯದಲ್ಲಿ ಹೂಡಿಕೆ ಮಾಡಲು ನಾವು ನಂಬುತ್ತೇವೆ. ಈಗರ್ ಮೂಲಕ ಪ್ರವೇಶ ಪಡೆಯಿರಿ ಮತ್ತು ನಿಮ್ಮ ಪ್ರಯಾಣವನ್ನು ಪ್ರಾರಂಭಿಸಲು ಅನುದಾನವನ್ನು ಪಡೆಯಿರಿ.",
                    "cta": "ನನ್ನ ಅರ್ಹತೆಯನ್ನು ಪರಿಶೀಲಿಸಿ",
                    "pro_tip": "ಪ್ರೊ ಟಿಪ್:",
                    "pro_tip_desc": "<0>₹5,000 ಎಲೈಟ್ ಅನುದಾನ</0> ಅನ್ಲಾಕ್ ಮಾಡಲು 800 ಸ್ಕೋರ್ ಪಡೆಯಿರಿ.",
                    "how_title": "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ?",
                    "steps": {
                        "1": "'ಪರಿಶೀಲಿಸಿದ ಬಹುಮಾನ' ಬ್ಯಾಡ್ಜ್ ಹೊಂದಿರುವ ಕಾಲೇಜನ್ನು ಹುಡುಕಿ.",
                        "2": "ನಮ್ಮ ಲಿಂಕ್ ಮೂಲಕ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ ಮತ್ತು ಪ್ರವೇಶ ಪಡೆಯಿರಿ.",
                        "3": "ನಿಮ್ಮ ಪ್ರವೇಶ ಪುರಾವೆಯನ್ನು ನಿಮ್ಮ ಈಗರ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
                        "4": "ನಿಮ್ಮ ಅನುದಾನವನ್ನು ವೋಚರ್ ಅಥವಾ ಅಮೆಜಾನ್ ಗಿಫ್ಟ್ ಕಾರ್ಡ್ ಆಗಿ ಪಡೆಯಿರಿ."
                    },
                    "why_title": "ನಾವು ಇದನ್ನು ಏಕೆ ಮಾಡುತ್ತಿದ್ದೇವೆ?",
                    "why_desc": "ಪ್ರವೇಶಾತಿ ವೆಚ್ಚದಾಯಕ. ಹೊಸ ಬ್ಯಾಗ್, ಲ್ಯಾಪ್‌ಟಾಪ್ ಅಥವಾ ಪುಸ್ತಕಗಳನ್ನು ಖರೀದಿಸಲು—ನಿಮ್ಮ ಮೊದಲ ಹೆಜ್ಜೆಯಲ್ಲಿ ನಾವು ಸಹಾಯ ಮಾಡಲು ಬಯಸುತ್ತೇವೆ.",
                    "mission": "\"ಸೀಟು ಪಡೆಯುವುದು ಮಾತ್ರ ನಮ್ಮ ಗುರಿಯಲ್ಲ, ಅದರಲ್ಲಿ ಯಶಸ್ವಿಯಾಗಲು ನಿಮಗೆ ಬೇಕಾದ ಎಲ್ಲವನ್ನೂ ಒದಗಿಸುವುದು ನಮ್ಮ ಉದ್ದೇಶ.\""
                }
            },
            "profile": {
                "ghost": {
                    "title": "ಘೋಸ್ಟ್ ಪ್ರೊಫೈಲ್?",
                    "desc": "ನಾವು ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಡೇಟಾವನ್ನು ಹುಡುಕಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ನೀವು ಮತ್ತೆ ಸೈನ್ ಇನ್ ಮಾಡಬೇಕಾಗಬಹುದು.",
                    "signin": "ಸೈನ್ ಇನ್ / ರಿಜಿಸ್ಟರ್",
                    "retry": "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
                },
                "scout_mode": "ಸ್ಕೌಟ್ ಮೋಡ್ ಸಕ್ರಿಯವಾಗಿದೆ",
                "cards": {
                    "readiness": "ಸ್ಕೌಟ್ ಸಿದ್ಧತೆ",
                    "academic": "ಶೈಕ್ಷಣಿಕ",
                    "archetype": "ಆರ್ಕಿಟೈಪ್",
                    "momentum": "ಮೊಮೆಂಟಮ್",
                    "peak": "ಉತ್ತುಂಗ",
                    "rising": "ಏರುತ್ತಿರುವ",
                    "verified": "ಪರಿಶೀಲಿಸಿದ ಐಡೆಂಟಿಟಿ",
                    "title_default": "ಈಗರ್ ಅನ್ವೇಷಕ"
                },
                "stats_card": {
                    "title": "ಕೌಶಲ್ಯ ವಿಶ್ಲೇಷಣೆ",
                    "footer": "ನಿಮ್ಮ ರಸಪ್ರಶ್ನೆ ಕಾರ್ಯಕ್ಷಮತೆ ಆಧಾರದ ಮೇಲೆ ಅಂಕಿಅಂಶಗಳು ನವೀಕರಿಸಲ್ಪಡುತ್ತವೆ.",
                    "logic": "ಲಾಜಿಕ್",
                    "creativity": "ಸೃಜನಶೀಲತೆ",
                    "leadership": "ನಾಯಕತ್ವ",
                    "profileviews": "ಪ್ರೊಫೈಲ್ ವೀಕ್ಷಣೆಗಳು",
                    "shortlisted": "ಶಾರ್ಟ್‌ಲಿಸ್ಟ್",
                    "applications": "ಅರ್ಜಿಗಳು"
                },
                "scout_mode_card": {
                    "title": "ಸ್ಕೌಟ್ ಮೋಡ್",
                    "active": "ಸಕ್ರಿಯ ಮತ್ತು ಗೋಚರ",
                    "inactive": "ಪ್ರಸ್ತುತ ಅಡಗಿಸಲಾಗಿದೆ",
                    "desc_active": "ಪರಿಶೀಲಿಸಿದ ಕಾಲೇಜುಗಳು ಮತ್ತು ನೇಮಕಾತಿದಾರರು ನಿಮ್ಮ ಸಾಧನೆಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಮತ್ತು ವಿದ್ಯಾರ್ಥಿವೇತನವನ್ನು ನೀಡಲು ಅನುಮತಿಸಿ.",
                    "desc_inactive": "ಕಾಲೇಜುಗಳು ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ವೀಕ್ಷಿಸಲು ಸಕ್ರಿಯಗೊಳಿಸಿ.",
                    "companies_viewing": "ಕಂಪನಿಗಳು ವೀಕ್ಷಿಸುತ್ತಿವೆ",
                    "preview_button": "ಸಾರ್ವಜನಿಕ ಕಾರ್ಡ್ ಪೂರ್ವವೀಕ್ಷಣೆ"
                },
                "global_rank": {
                    "top_percent": "ಟಾಪ್",
                    "global": "ಜಾಗತಿಕ",
                    "outperforming_desc": "ನೀವು ಜಾಗತಿಕವಾಗಿ {{percent}}% ಈಗರ್ ಅನ್ವೇಷಕರಿಗಿಂತ ಉತ್ತಮವಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತಿದ್ದೀರಿ.",
                    "leaderboard": "ಲೀಡರ್‌ಬೋರ್ಡ್"
                },
                "activity": {
                    "quiz_completed": "\"ವೃತ್ತಿ ಹೊಂದಾಣಿಕೆ ರಸಪ್ರಶ್ನೆ\" ಪೂರ್ಣಗೊಳಿಸಲಾಗಿದೆ",
                    "colleges_shortlisted": "{{count}} ಹೊಸ ಇಂಜಿನಿಯರಿಂಗ್ ಕಾಲೇಜುಗಳನ್ನು ಶಾರ್ಟ್‌ಲಿಸ್ಟ್ ಮಾಡಲಾಗಿದೆ",
                    "days_ago": "{{count}} ದಿನಗಳ ಹಿಂದೆ"
                },
                "onboarding": {
                    "title": "ನಿಮ್ಮ ಈಗರ್ ಐಡೆಂಟಿಟಿ ಹೆಚ್ಚಿಸಿ",
                    "subtitle": "ಸ್ಕೌಟ್ ಮೋಡ್ ಅನ್‌ಲಾಕ್ ಮಾಡಲು ಮತ್ತು ನೇಮಕಾತಿದಾರರ ಗಮನ ಸೆಳೆಯಲು ಈ ಹಂತಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ.",
                    "potential_points": "ಪೊಟೆನ್ಷಿಯಲ್ ಪಾಯಿಂಟ್ಸ್",
                    "completion": "ಪೂರ್ಣಗೊಳಿಸುವಿಕೆ",
                    "steps": {
                        "avatar": "ವೃತ್ತಿಪರ ಫೋಟೋ ಸೇರಿಸಿ",
                        "quiz": "ವೃತ್ತಿ ರಸಪ್ರಶ್ನೆ ಪೂರ್ಣಗೊಳಿಸಿ",
                        "location": "ಊರು ನವೀಕರಿಸಿ",
                        "interests": "3 ಆಸಕ್ತಿಗಳನ್ನು ಆರಿಸಿ",
                        "skills": "ಯಾವುದಾದರೂ ಕೌಶಲ್ಯ ಸೇರಿಸಿ",
                        "projects": "ಪ್ರಾಜೆಕ್ಟ್ ಪ್ರದರ್ಶಿಸಿ",
                        "status": "ಪೂರ್ಣಗೊಂಡಿದೆ"
                    }
                },
                "psychometric": {
                    "title": "ಮನೋವೈಜ್ಞಾನಿಕ ಒಳನೋಟ",
                    "result_prefix": "ನೀವು ಒಬ್ಬ",
                    "button": "ಪೂರ್ಣ ವರದಿ ನೋಡಿ",
                    "descriptions": {
                        "explorer": "ನೀವು ಪ್ರಪಂಚದ ಪತ್ತೇದಾರಿ. ಕುತೂಹಲ ನಿಮ್ಮನ್ನು ಓಡಿಸುತ್ತದೆ. ನೀವು ವಿಶ್ಲೇಷಿಸಲು, ಸಂಶೋಧಿಸಲು ಮತ್ತು ಸಂಕೀರ್ಣವಾದ ಒಗಟುಗಳನ್ನು ಪರಿಹರಿಸಲು ಇಷ್ಟಪಡುತ್ತೀರಿ.... ಕಾಲೇಜುಗಳು ನಿಮ್ಮ ಅನನ್ಯ ಕೌಶಲಗಳನ್ನು ಏಕೆ ಹುಡುಕುತ್ತಿವೆ ಎಂಬುದನ್ನು ಕಂಡುಕೊಳ್ಳಿ."
                    }
                },
                "share_button": {
                    "default": "ಈಗರ್ ವನ್ ಕಾರ್ಡ್ ಹಂಚಿಕೊಳ್ಳಿ",
                    "preparing": "ಸ್ಕೋರ್‌ಕಾರ್ಡ್ ಸಿದ್ಧವಾಗುತ್ತಿದೆ...",
                    "ready": "ಪೋಸ್ಟ್ ಮಾಡಲು ಸಿದ್ಧ!",
                    "failed": "ಸೆರೆಹಿಡಿಯುವಿಕೆ ವಿಫಲವಾಗಿದೆ"
                },
                "scout_one": {
                    "foundation_stage": "ಅಡಿಪಾಯ ಹಂತ"
                },
                "titles": {
                    "identity": "ನಿಮ್ಮ ಈಗರ್ ಐಡೆಂಟಿಟಿ ಹೆಚ್ಚಿಸಿ",
                    "interests": "ವೃತ್ತಿ ಆಸಕ್ತಿಗಳು",
                    "skills": "ಪರಿಶೀಲಿಸಿದ ಕೌಶಲ್ಯಗಳು",
                    "projects": "ಪ್ರಾಜೆಕ್ಟ್ಗಳು",
                    "badges": "ಗಳಿಸಿದ ಬ್ಯಾಡ್ಜ್‌ಗಳು",
                    "activity": "ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ",
                    "academic": "ಶೈಕ್ಷಣಿಕ ವಿವರಗಳು"
                }
            }
        }
    }
};

i18n
    .use(initReactI18next) // Removed LanguageDetector
    .init({
        resources,
        lng: 'en', // Force English immediately
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false // CRITICAL: Disable Suspense requirement for now
        }
    });

export default i18n;
